import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './auth/login/login.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { AuthGuard } from './guard/auth.guard';
import { LandingPageComponent } from './auth/landing-page/landing-page.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { Page404Component } from './auth/page404/page404.component';
import { Page401Component } from './auth/page401/page401.component';
import { Page403Component } from './auth/page403/page403.component';
import { LoadingPageComponent } from './auth/loading-page/loading-page.component';
import { SamlRequestComponent } from './auth/saml-request/saml-request.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  // {
  //   path: 'login',
  //   component: LoginComponent,
  //   data: {
  //     title: 'Login Page'
  //   }
  // },
  {
    path: "login",
    component: SamlRequestComponent,
    data: {
      title: "SAML Request",
    },
  },
  {
    path: 'login/:url',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'forgetpassword',
    component: ForgetPasswordComponent,
    data: {
      title: 'Forget Password'
    }
  },
  {
    path: 'resetpassword/:token',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password'
    }
  },
  {
    path: 'landing-page/:samlResponse/:azureAdMail',
    component: LandingPageComponent,
    data: {
      title: 'Landing page'
    }
  },
  {
    path: 'landing-page',
    component: LandingPageComponent,
    data: {
      title: 'Landing page'
    }
  },
  {
    path: 'log-out',
    component: LogoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Logged-Out'
    }
  },
  {
    path: '404-page',
    component: Page404Component,
    data: {
      title: "Page 404"
    }
  },
  {
    path: '401-page',
    component: Page401Component,
    data: {
      title: "Page 401"
    }
  },
  {
    path: '403-page',
    component: Page403Component,
    data: {
      title: "Page 403"
    }
  },
  {
    path: 'loading-page',
    component: LoadingPageComponent,
    data: {
      title: 'Loading page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'incident',
        loadChildren: () => import('./views/incident/incident.module').then(m => m.IncidentModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'risk',
        loadChildren: () => import('./views/risk/risk.module').then(m => m.RiskModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'master',
        loadChildren: () => import('./views/master/master.module').then(m => m.MasterModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'screen-master',
        loadChildren: () => import('./views/screenmaster/screen-master.module').then(m => m.ScreenMasterModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'role-access',
        loadChildren: () => import('./views/roleaccess/roleaccess.module').then(m => m.RoleaccessModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'test',
        loadChildren: () => import('./views/testing/testing.module').then(m => m.TestingModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'litigation',
        loadChildren: () => import('./views/litigation/litigation.module').then(m => m.LitigationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'organization',
        loadChildren: () => import('./views/organization/organization.module').then(m => m.OrganizationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'reports',
        loadChildren: () => import('./views/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthGuard]
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
